import { render, staticRenderFns } from "./LatestNews.vue?vue&type=template&id=4eca9f4d"
import script from "./LatestNews.vue?vue&type=script&lang=js"
export * from "./LatestNews.vue?vue&type=script&lang=js"
import style0 from "./LatestNews.vue?vue&type=style&index=0&id=4eca9f4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LatestNews.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports